export default __webpack_public_path__ + "img/pin_icons/chiller_b.png";